const POSITIVE_FEEDBACK_VARIANT = 'good'
const NEGATIVE_FEEDBACK_VARIANT = 'bad'

export default { POSITIVE_FEEDBACK_VARIANT, NEGATIVE_FEEDBACK_VARIANT }
